import type { Outline } from "../math/samplePath";

/** Original 11 × 8 pixel invader. Eyes are empty pixels, revealed in the final fill. */
export const invaderPixels = [
  "00100000100",
  "00110001100",
  "00111111100",
  "01101110110",
  "11111111111",
  "10111111101",
  "10100000101",
  "00110001100",
] as const;

// Exposed outer boundary of the connected pixel union, clockwise in SVG coordinates.
// Straight cubic segments preserve the source's exact right-angle corners.
export const invaderVertices: readonly (readonly [number, number])[] = [
  [0, 4],
  [1, 4],
  [1, 3],
  [2, 3],
  [2, 0],
  [3, 0],
  [3, 1],
  [4, 1],
  [4, 2],
  [7, 2],
  [7, 1],
  [8, 1],
  [8, 0],
  [9, 0],
  [9, 3],
  [10, 3],
  [10, 4],
  [11, 4],
  [11, 7],
  [10, 7],
  [10, 5],
  [9, 5],
  [9, 8],
  [7, 8],
  [7, 7],
  [8, 7],
  [8, 6],
  [3, 6],
  [3, 7],
  [4, 7],
  [4, 8],
  [2, 8],
  [2, 5],
  [1, 5],
  [1, 7],
  [0, 7],
];
export const invader: Outline = invaderVertices.map((a, i) => {
  const b = invaderVertices[(i + 1) % invaderVertices.length];
  return {
    from: { x: a[0], y: a[1] },
    c1: { x: a[0] + (b[0] - a[0]) / 3, y: a[1] + (b[1] - a[1]) / 3 },
    c2: {
      x: a[0] + (2 * (b[0] - a[0])) / 3,
      y: a[1] + (2 * (b[1] - a[1])) / 3,
    },
    to: { x: b[0], y: b[1] },
  };
});
